import { Routes, Route } from "react-router-dom";

import { AssetPageLayout, Home } from "legacyNext/pages";
import {
    Overview,
    Sustainability,
    Consumption,
    Economy,
} from "legacyNext/pages/Asset";
import {
    AssetRisk,
    LegacyMap,
    SearchList,
} from "legacyNext/pages/Home/components";
import { LegacyNextStoreProvider } from "legacyNext/store";
import { NotFoundPage } from "pages";

import { LegacyNextRoute } from "./Route";

export const LegacyNextRoutes = () => {
    return (
        <LegacyNextStoreProvider>
            <Routes>
                <Route element={<LegacyNextRoute />}>
                    <Route element={<Home />}>
                        <Route index element={<LegacyMap />} />
                        <Route path="list" element={<SearchList />} />
                        <Route path="graph" element={<AssetRisk />} />
                    </Route>
                    <Route path="asset/:id" element={<AssetPageLayout />}>
                        <Route index element={<Overview />} />
                        <Route path="consumption" element={<Consumption />} />
                        <Route
                            path="sustainability"
                            element={<Sustainability />}
                        />
                        <Route path="economy" element={<Economy />} />
                    </Route>
                </Route>

                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </LegacyNextStoreProvider>
    );
};
